<template>
  <div
    id="feeorder"
    class="pb-3"
  >
    <!-- 標題 -->
    <v-title>
      <font-awesome-icon icon="cart-plus" />
      選擇繳款項目
      <span slot="etext">
        &emsp;&nbsp;Choose Fee Order
      </span>
    </v-title>
    <hr>
    <!-- 項目內容 -->
    <div
      id="myTabContent"
      class="tab-content mb-3"
    >
      <!-- 購物車 -->
      <div
        id="ToCart"
        class="cart-icon"
      >
        <a href="/#/payment">
          <v-font
            fontCss="badge badge-pill badge-danger cart-span"
            :font-text="String(AllTota)"
          />
          <font-awesome-icon
            icon="shopping-cart"
            class="fa-2x"
          />
        </a>
      </div>
      <!-- 內容主版 -->
      <ul
        id="ul_feeorder"
        class="nav nav-tabs lh-fs"
        role="tablist"
      >
        <li class="nav-item">
          <a
            id="a_personal"
            class="nav-link"
            :class="[isActive ? 'active' : '']"
            :href="'#/feeorder/personal'"
            @click="FeeorderList('true')"
            role="tab"
            aria-controls="div-personal"
            aria-selected="true"
          >
            個人繳款項目
            <br>
            <v-font
              font-css="spanfs"
              font-text="Personal Fee Order"
            />
          </a>
        </li>
        <li class="nav-item">
          <a
            id="a_public"
            class="nav-link"
            :class="[isActives ? 'active' : '']"
            :href="'#/feeorder/public'"
            @click="FeeorderList('false')"
            role="tab"
            aria-controls="div-public"
            aria-selected="false"
          >
            公開收費項目
            <br>
            <v-font
              font-css="spanfs"
              font-text="Public Fee Item"
            />
          </a>
        </li>
      </ul>
      <Personal v-if="isActive" />
      <Public v-if="isActives" />
    </div>
    <!-- 繳費鈕 -->
    <v-button
      class="lh-fs"
      btn-text="繳費去"
      btn-type="warning"
      btn-size="lg"
      btn-block="true"
      @click.native="GoToPay"
    >
      <br slot="eg">
      <v-font
        slot="icon"
        font-css="spanfs"
        font-text="Go to pay"
      />
    </v-button>
  </div>
</template>

<script>
import { apiFeeorderShopquerys } from '../../../Api/api'
import Public from './Public'
import Personal from './Personal'
export default {
  components: {
    Public,
    Personal
  },
  data () {
    return {
      AllTota: 0,
      isActive: true,
      isActives: false
    }
  },
  created () { // 接收項目加入購物車訊息
    const vm = this
    vm.$bus.$on('Cart', data => {
      vm.ToCart(data)
    })
  },
  methods: {
    GoToPay () {
      this.$router.push({ name: 'Payment' }) // 導向 證件申請頁面
    },
    ToCart (data) { // 查詢購物車數量 F_API 011
      if (data === 'true') {
        const NewData = JSON.parse(localStorage.getItem('M_Identity'))
        // 呼叫API
        apiFeeorderShopquerys(NewData).then(
          res => {
            if (res.status === 200) {
              if (res.data.ErrorCode === 0) {
                this.AllTota = res.data.Data.length
              }
            }
          }
        )
      }
    },
    FeeorderList (data) { // 觸發切換頁籤
      const vm = this
      if (data === 'true') {
        vm.isActive = true
        vm.isActives = false
      } else {
        vm.isActive = false
        vm.isActives = true
      }
    }
  }
}
</script>

<style lang="scss">
  a {
    color: #000000;
    text-decoration: none;
    background-color: transparent;
  }
  a:hover {
    color: #fdb408;
  }
  #ToCart {
    cursor: pointer;
  }
  .cart-icon{
    display: block;
    right: 3%;
    position: fixed;
    top: 78%;
    float:right;
    z-index: 999;
    color: #ffc300d1;
  }
  .cart-span {
    position: fixed;
    display: block;
    float:right;
    right: 3.2%;
    z-index: 999;
  }
  @media only screen and (max-width:600px) {
    .cart-icon {
      top: 80%;
    }
  }
</style>
